import React, { Component } from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { MenuItem, FormControl, Select, InputLabel, FilledInput, Checkbox } from '@material-ui/core';
import { SelectIcon, SelectInvertIcon, CheckCircleUnchecked, CheckCircleChecked } from '../icons';

import './dropdown.scss';

@observer
export class Dropdown extends Component {
    @observable singleSelectValue = '';
    @observable multiSelectValue = [];
    @observable selectOpened = false;

    constructor(props) {
        super(props);
        this.resetState = this.props.resetState ? this.props.resetState.bind(this) : this.resetState.bind(this);
    }

    updateState(event, key) {
        if (key === 'multiSelectValue') {
            this[key].push(event.target.value);
            return;
        }
        this[key] = event.target.value;
    }

    onOpen(event) {
        this.selectOpened = true;
    }

    onClose(event) {
        this.selectOpened = false;
    }

    renderValue(selected, source, multiple) {
        const reset = this.resetState(selected, multiple),
            selectedSize = selected.length;

        if (reset) {
            return false;
        }

        return <div>
            <span className='nlsentence-dropdownwrap' style={{ margin: 0 }}>
                {multiple ? selected.map((value, key) => {
                    return `${this.renderLabel(source, value)}${this.suffix(key, selectedSize)}`;
                }) : this.renderLabel(source, selected)
                }
            </span>
        </div>;
    }

    renderLabel(source, value) {
        const item = source.find(s => parseInt(s.value) === value);
        return item ? item.label : null;
    }

    resetState(selected, multiple) {
        const reset = multiple ? selected.filter(item => item.length === 0).length > 0 || selected.length === 0 : !String(selected).length > 0;

        if (!reset) {
            return false;
        }

        this.singleSelectValue = '';
        this.multiSelectValue = [];
        this.selectOpened = false;
        return true;
    }

    suffix(key, selectedSize) {
        if (selectedSize < 1) {
            return '';
        }

        if (selectedSize > 2 && key < selectedSize - 2) {
            return ', ';
        } else if (key !== selectedSize - 1 || (selectedSize > 2 && key === selectedSize - 2)) {
            return ' and ';
        }

        return '';
    }

    render() {
        const { name, multiple, source, label, placeholder, value, onChange, emptyOption, emptyLabel } = this.props,
            empty = <MenuItem key='empty' value=''><h4 style={{ margin: 0 }}>{emptyLabel}</h4></MenuItem>,
            classNames = `nlsentence-dropdown ${multiple ? 'multiple' : ''}`;

        let propValue = value || (multiple ? this.multiSelectValue.slice() : this.singleSelectValue);

        if (typeof propValue === typeof object) {
            propValue = propValue.slice();
        }

        if (multiple && !propValue.isArray) {
            propValue = [];
        }

        return <FormControl variant='filled' className={classNames}>
            <InputLabel
                id={`${name}-label`}
                className='sr-only'
                htmlFor={name}
            >
                {label}
            </InputLabel>
            {propValue !== undefined && String(propValue).length > 0
                ? null
                : <span className='nlsentence-dropdownplaceholder'>{placeholder}</span>
            }
            <Select
                id={name}
                IconComponent={this.selectOpened ? SelectInvertIcon : SelectIcon}
                multiple={multiple}
                onChange={onChange || ((event) => this.updateState(event, multiple ? 'multiSelectValue' : 'singleSelectValue'))}
                onOpen={(event) => this.onOpen(event)}
                onClose={(event) => this.onClose(event)}
                renderValue={(selected) => this.renderValue(selected, source, multiple)}
                disableUnderline
                open={this.selectOpened}
                value={propValue}
                displayEmpty={false}
                MenuProps={{
                    getContentAnchorEl: null,
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left'
                    },
                    className: classNames
                }}
                input={
                    <FilledInput
                        name={name}
                        id={name}
                    />
                }
            >
                {emptyOption ? empty : null}
                {
                    source.map(item => (
                        <MenuItem key={item.value} value={item.value}>
                            {multiple &&
                                <Checkbox
                                    icon={<CheckCircleUnchecked />}
                                    checkedIcon={<CheckCircleChecked />}
                                    checked={propValue.indexOf(item.value) > -1} />
                            }
                            <span className='nlsentence-dropdownitem'>{item.label}</span>
                        </MenuItem>
                    ))
                }
            </Select>
        </FormControl>;
    }
}
